function crc32(bytes) {
  let crc = 0xffffffff;
  for (const byte of bytes) { crc ^= byte; for (let bit = 0; bit < 8; bit++) crc = (crc >>> 1) ^ (0xedb88320 & -(crc & 1)); }
  return (crc ^ 0xffffffff) >>> 0;
}
export function zipFiles(files) {
  const chunks = [], directory = [];
  let offset = 0, directorySize = 0;
  const encoder = new TextEncoder();
  for (const file of files) {
    const name = encoder.encode(file.name), bytes = file.bytes, crc = crc32(bytes);
    const header = new Uint8Array(30 + name.length); const view = new DataView(header.buffer);
    view.setUint32(0, 0x04034b50, true); view.setUint16(4, 20, true);
    view.setUint32(14, crc, true); view.setUint32(18, bytes.length, true); view.setUint32(22, bytes.length, true); view.setUint16(26, name.length, true); header.set(name, 30);
    chunks.push(header, bytes);
    const entry = new Uint8Array(46 + name.length); const central = new DataView(entry.buffer);
    central.setUint32(0, 0x02014b50, true); central.setUint16(4, 20, true); central.setUint16(6, 20, true);
    central.setUint32(16, crc, true); central.setUint32(20, bytes.length, true); central.setUint32(24, bytes.length, true); central.setUint16(28, name.length, true); central.setUint32(42, offset, true); entry.set(name, 46);
    directory.push(entry); directorySize += entry.length; offset += header.length + bytes.length;
  }
  const end = new Uint8Array(22); const view = new DataView(end.buffer);
  view.setUint32(0, 0x06054b50, true); view.setUint16(8, files.length, true); view.setUint16(10, files.length, true); view.setUint32(12, directorySize, true); view.setUint32(16, offset, true);
  return new Blob([...chunks, ...directory, end], { type: 'application/zip' });
}
export async function downloadEmoticons(url) {
  const response = await fetch(url);
  if (!response.ok) throw new Error('이모티콘 이미지를 불러오지 못했습니다.');
  const bitmap = await createImageBitmap(await response.blob());
  try {
    const canvas = document.createElement('canvas'), context = canvas.getContext('2d');
    const files = [];
    for (let row = 0; row < 3; row++) for (let column = 0; column < 4; column++) {
      const left = Math.round(column * bitmap.width / 4), top = Math.round(row * bitmap.height / 3);
      const width = Math.round((column + 1) * bitmap.width / 4) - left, height = Math.round((row + 1) * bitmap.height / 3) - top;
      canvas.width = width; canvas.height = height;
      context.drawImage(bitmap, left, top, width, height, 0, 0, width, height);
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
      if (!blob) throw new Error('이모티콘을 나누지 못했습니다.');
      files.push({ name: `erion_${String(files.length + 1).padStart(2, '0')}.png`, bytes: new Uint8Array(await blob.arrayBuffer()) });
    }
    const zip = zipFiles(files); const objectUrl = URL.createObjectURL(zip);
    const anchor = document.createElement('a'); anchor.href = objectUrl; anchor.download = 'erion_emoticons.zip'; anchor.click();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  } finally { bitmap.close(); }
}
